import _ from 'lodash'

export const TOGGLE_ACCOMMODATION_MODAL = 'TOGGLE_ACCOMMODATION_MODAL'

export const toggleAccommodationModal = (windowOffset) => (dispatch, getState) => {
  const currentState = _.get(getState(), 'accommodationModalData')
  if (currentState.isOpen) {
    document.body.setAttribute('style', '')
    setTimeout(() => window.scrollTo(0, currentState.windowOffset), 0)
  } else {
    document.body.setAttribute('style', `overflow: hidden;`)
  }
  dispatch({ type: TOGGLE_ACCOMMODATION_MODAL, payload: windowOffset })
}
